class TestimonialsBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.mainSlider = block.querySelector('.testimonials__main-slider');
    this.logoSlider = block.querySelector('.testimonials__logos .swiper-container');
    this.videoButtons = block.querySelectorAll('button.testimonials__image');
    this.overlay = block.querySelector('.testimonials__overlay');
    this.iframe = block.querySelector('.testimonials__iframe');

    this.mainSwiperOptions = {
      autoHeight: true,
      speed: 400,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: this.mainSlider.querySelector('.slider__slider-nav-button--next'),
        prevEl: this.mainSlider.querySelector('.slider__slider-nav-button--prev'),
        disabledClass: 'slider__slider-nav-button--disabled',
      },
      pagination: {
        el: this.block.querySelector('.swiper-pagination'),
        type: 'bullets',
      },
      keyboard: {
        enabled: true,
      },
      threshold: 1,
    };

    this.videoButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.iframe.innerHTML = `<iframe src="https://player.vimeo.com/video/${button.dataset.video.replace(
          /^https.+\/([0-9]+)$/,
          '$1'
        )}?autoplay=1&title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        this.block.classList.add('testimonials--overlay-visible');
      });
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target.classList.contains('testimonials__overlay')) {
          this.closeVideo();
        }
      });

      this.overlay.querySelector('.testimonials__close').addEventListener('click', (e) => {
        this.closeVideo();
      });

      window.addEventListener('keydown', (e) => {
        if (e.code === 'Escape') {
          this.closeVideo();
        }
      });

      this.logoSwiper = new Swiper(this.logoSlider, {
        speed: 400,
        slidesPerView: 'auto',
        spaceBetween: 16,
        watchSlidesVisibility: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        breakpoints: {
          768: {
            spaceBetween: 24,
          },
        },
      });

      this.mainSwiperOptions.thumbs = {
        swiper: this.logoSwiper,
      };
    }

    this.mainSwiper = new Swiper(this.mainSlider, this.mainSwiperOptions);
  }

  closeVideo() {
    this.block.classList.remove('testimonials--overlay-visible');
    this.iframe.innerHTML = '';
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.testimonials').forEach((block) => {
  new TestimonialsBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=testimonials', ($block, attributes) => {
    new TestimonialsBlock($block.find('.testimonials').get(0), attributes);
  });
}